(function () {
  function downgrade(el, newTag) {
    if (el.dataset.headingHygieneChecked) return;
    var replacement = document.createElement(newTag);
    for (var i = 0; i < el.attributes.length; i++) {
      var attr = el.attributes[i];
      replacement.setAttribute(attr.name, attr.value);
    }
    replacement.innerHTML = el.innerHTML;
    replacement.dataset.headingHygieneChecked = 'true';
    el.replaceWith(replacement);
  }

  function checkH1(el) {
    if (el.dataset.headingHygieneSeenAtLoad || el.dataset.headingHygieneChecked) return;
    downgrade(el, 'div');
  }

  function checkH2(el) {
    if (el.dataset.headingHygieneChecked) return;
    var text = (el.textContent || '').trim().toLowerCase();
    if (text.indexOf('cookie') !== -1 && text.indexOf('consent') !== -1) {
      downgrade(el, 'p');
    }
  }

  function sweep(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'H1') checkH1(node);
    if (node.tagName === 'H2') checkH2(node);
    if (node.querySelectorAll) {
      node.querySelectorAll('h1').forEach(checkH1);
      node.querySelectorAll('h2').forEach(checkH2);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('h1').forEach(function (el) {
      el.dataset.headingHygieneSeenAtLoad = 'true';
    });

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(sweep);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
